import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { Button, Form } from 'react-bootstrap'
import { FaRegSquarePlus } from "react-icons/fa6";
import * as yup from 'yup';
import { useFormik } from 'formik';
import toast from 'react-hot-toast'
import { getCategoryListing } from '../../api/context/category'
import imageToBase64 from 'image-to-base64/browser';
import moment from 'moment';
import { BiSolidEditAlt } from "react-icons/bi";
import CreateSubCategory from './CreateSubCategory'
import { createSubCategory, deleteSubCategory, editSubCategory, getSubCategoryListing, getSubCategoryProductsListing, statusSubCatUpdate } from '../../api/context/subcategory';
import CustomisedModal from '../../components/Modal/CustomisedModal';
import { MdDelete } from 'react-icons/md';
import { IoMdArrowBack } from "react-icons/io";
import { checkUserPermissions } from '../../helpers/permission';
import DataTable from "react-data-table-component";
import deleteIcon from "../../assets/images/delete.svg";
import editIcon from "../../assets/images/edit.svg";
import { Box, Paper, Tooltip } from "@mui/material";
import Loader from '../../components/loader/loader';
import { deleteProduct, deleteSubCategoryProduct, statusProductUpdate } from '../../api/context/products';

const queueDatatableCustomStyles = {
    headCells: {
        style: {
            fontWeight: '600',
            fontSize: '14px',

        },
    },
    cells: {
        style: {
            fontSize: '12px',
            fontWeight: '500',
            padding: '12px',
        },
    },

};

const SubCategoriesProducts = () => {

    const [show, setShow] = useState(false);

    const { state } = useLocation();

    const subcat = state?.data?.title;

    const { id } = useParams();

    const navigate = useNavigate();

    const handleShow = () => setShow(true);

    const [loading, setLoading] = useState(false);
    const [update, setUpdate] = useState(false);
    const [category, setCategory] = useState([]);
    const [subcategory, setSubCategory] = useState([]);
    // Inside your component
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [modal, setModal] = useState(false);
    const [deletingId, setDeletingId] = useState("");
    const [productcatId, setProductCatId] = useState("");
    const [subcatId, setSubCatId] = useState("");

    const toggleModal = () => {
        setModal(!modal);
    };

    const handleClose = () => {
        formik.resetForm();
        setShow(false);
        setSelectedCategory(null);
    };

    const validationSchema = yup.object().shape({
        title: yup
            .string('Enter your firstName')
            .trim()
            .required('Title is required'),
        desc: yup
            .string('Enter your lastName')
            .trim()
            .required('Description is required'),
        isActive: yup
            .boolean()
            .required('isActive is required'),
    });

    const formik = useFormik({
        initialValues: {
            subCategoryId: '',
            subSubCategoryId: '',
            title: '',
            desc: '',
            img: '',
            img_view: '',
            isActive: true
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {
            setLoading(true);
            if (values.img == '') {
                delete values.img;
            }
            delete values.img_view;
            if (selectedCategory?.id) {
                editSubCategory(values)((response) => {
                    if (response && response?.data?.statusCode == 200) {
                        resetForm();
                        toast.success("Category Updated Successfully")
                        handleClose();
                        setUpdate(!update);
                        setSelectedCategory(null);
                        setLoading(false);
                    } else {
                        setLoading(false);
                        toast.error(response?.data?.message);
                    }
                })
            } else {
                createSubCategory(values)((response) => {
                    if (response && response?.data?.statusCode == 200) {
                        resetForm();
                        toast.success("Category Created Successfully")
                        handleClose();
                        setUpdate(!update);
                        setLoading(false);
                        setSelectedCategory(null);
                    } else {
                        setLoading(false);
                        toast.error(response?.data?.message);
                    }
                })
            }
        },
    });

    const columns = [
        {
            id: 'productname',
            name: 'Product Name',
            selector: (row) => row?.product?.productName,
            cell: (row) => <Tooltip title={row?.product?.productName} disableInteractive placement='top'><div className='text-truncate'>{row?.product?.productName}</div></Tooltip>,
            width: "350px",

        },

        // {
        //     id: 'promocode',
        //     name: 'Promocode',
        //     selector: (row) => row?.product?.promocode,
        //     cell: (row) => <Tooltip title={row?.product?.promocode} disableInteractive placement='top'><div className='text-truncate'>{row?.product?.promocode}</div></Tooltip>,
        //     width: "220px",

        // },


        {
            id: 'colors',
            name: 'Colors',
            selector: (row) => row?.product?.color,
            cell: (row) => <Tooltip title={row?.product?.color} disableInteractive placement='top'><div className='text-truncate color_code' style={{ width: "20px", height: "20px", border: '1px solid #EBEBEB', borderRadius: "50%", boxShadow: "0 0 12px -1px rgba(0, 0, 0, .11)", backgroundColor: row.product.color }}></div></Tooltip>,
            width: "150px",

        },


        {
            name: 'Status',
            selector: row => row.status,
            cell: (row) =>
                <div className='status_wrap_datatable'>
                    <Form.Check
                        type="switch"
                        id="custom-switch"
                        checked={row?.product?.isActive === true}
                        onChange={() => statusActive(row?.productId)}
                    />

                </div>,
            sortable: true,
            center: true,
            width: "150px",
        },

        {
            id: 'action',
            name: 'Action',
            cell: (row) =>
                <div>
                    {checkUserPermissions('manage_products') ?
                        <div className='d-flex align-items-center'>
                            <div className='d-flex flex-row gap-3' role='button'>
                                {/* <img src={editIcon} alt="" onClick={() => navigate('/edit-inventory/' + row?.productId)} /> */}
                                <img src={deleteIcon} alt="" onClick={() => handleConfirm(row?.productId, row?.subcategoryId)} />
                            </div>
                        </div>
                        :
                        <></>
                    }
                </div>,
            center: true,
            width: "220px",
        },
    ]

    const handleImageChange = async (e) => {
        const file = e?.target?.files[0];
        const maxSizeInBytes = 2 * 1024 * 1024;

        if (file.size > maxSizeInBytes) {
            toast.error("File size exceeds 2 MB limit", 'error')
            e.target.value = null;
            return;
        }
        const response = await imageToBase64(URL.createObjectURL(file));
        formik.setValues({
            ...formik.values,
            img: response,
            img_view: 'data:image/jpeg;base64,' + response,
        });
    }

    const getAllSubCategoriesProducts = () => {
        getSubCategoryProductsListing(id)((response) => {
            if (response?.statusCode === 200) {
                setSubCategory(response?.data);
                setLoading(false)
            } else {
                setSubCategory([])
                setLoading(false)
            }
        });
    };

    const getAllCategories = () => {
        getCategoryListing()((response) => {
            if (response?.statusCode == 200) {
                setCategory(response?.data?.subcategories);
            } else {
                // Handle error condition
            }
        });
    };


    const handleEditClick = (category) => {
        setSelectedCategory(category);
        console.log(category, "category");
        formik.setValues({
            ...formik.values,
            subSubCategoryId: String(category?.id ?? ''),
            subCategoryId: String(category?.subcategoryId ?? ''),
            title: category?.title ?? '',
            desc: category?.description ?? '',
            // img: category?.img ?? '',
            img_view: category?.img ?? '',
            isActive: category?.isActive ?? true
        });
        setShow(true);
    };

    const handleConfirm = (productcatId, subcatId) => {
        setModal(!modal);
        setProductCatId(productcatId);
        setSubCatId(subcatId);
    }

    const statusActive = (id) => {
        statusProductUpdate(id)((response) => {
            if (response?.data?.statusCode == 200) {
                setUpdate(!update);
            } else {

            }
        });

    }

    const deleteSubCatProducts = (productcatId, subcatId) => {
        deleteSubCategoryProduct({ productId: productcatId, subCategoryId: subcatId })((response) => {
            if (response?.data?.statusCode == 200) {
                setUpdate(!update);
                setModal(!modal);
            } else {

            }
        });

    }

    const previousUrl = () => {
        navigate(-1)
    }
    const addProduct = (subid) => {
        navigate('/create-sub-categories-products/' + subid)
    }

    useEffect(() => {
        setLoading(true);
        getAllSubCategoriesProducts()
    }, [update]);

    useEffect(() => {
        getAllCategories()
    }, []);

    console.log(subcategory);

    return (
        <>
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center">
                            <Link onClick={() => previousUrl()} className='back_btn_wrap'>
                                <IoMdArrowBack className='icon' />
                            </Link>
                            <h4 className="mb-sm-0">{subcat} Products</h4>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        {checkUserPermissions('manage_sub_category') ?
                            <div className='request_wrapper'>
                                <Button className='request_btn' onClick={() => addProduct(id)}><FaRegSquarePlus className='icon' />Add Product</Button>
                            </div>
                            :
                            <></>
                        }
                        <Box className="products-and-options" sx={{ mt: 1 }}>
                            <Paper square>
                                <div>
                                    <DataTable
                                        columns={columns}
                                        data={subcategory}
                                        progressPending={loading}
                                        progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
                                        pagination
                                        paginationServer
                                        // paginationTotalRows={totalRows}
                                        // paginationPerPage={limit}
                                        // onChangeRowsPerPage={handlePerRowsChange}
                                        // onChangePage={handlePageChange}
                                        // currentPage={page}
                                        customStyles={queueDatatableCustomStyles}
                                    />
                                </div>
                            </Paper>
                        </Box>
                    </div>
                    <CustomisedModal
                        isOpen={modal}
                        customClass={"policy_modal"}
                        toggle={toggleModal}
                    >
                        <h5>
                            Are you sure you want to remove this item?
                        </h5>
                        <div className="policy_Agree">
                            <Button
                                onClick={() => {
                                    setModal(!modal);
                                }}
                                size="lg"
                                className='btn_cancel'
                            >
                                Cancel
                            </Button>
                            <Button
                                size="lg"
                                className='btn'
                                onClick={() => deleteSubCatProducts(productcatId, subcatId)}
                            >
                                Remove
                            </Button>
                        </div>
                    </CustomisedModal>
                </div>
            </div>
        </>
    )
}

export default SubCategoriesProducts